import { drawInputSource2 } from '@/threejs/utils/canvasPatterns';
import type { InputSource } from './types';

export const grid2: InputSource = {
  label: 'Grid 2',
  value: 'grid2',
  draw: (ctx, width, height) => {
    drawInputSource2(ctx, width, height);
  },
};
